import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'distanceLabel',
  standalone: true
})
export class DistanceLabelPipe implements PipeTransform {

  transform(value: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case value?.applicationSubject === 'Lokalizacji obiektu budowlanego': {
        return 'Wskazanie odległości obiektu budowlanego od zewnętrznej krawędzi pasa drogowego';
      }
      case value?.applicationSubject === 'Lokalizacji reklamy': {
        return 'Wskazanie odległości reklamy od zewnętrznej krawędzie pasa drogowego';
      }
      case value?.applicationSubject === 'Lokalizacja reklamy posadowionej na obiekcie budowlanym': {
        return 'Wskazanie odległości reklamy posadowionej na obiekcie budowlanym od zewnętrznej krawędzie pasa drogowego';
      }
      default: {
        return 'Odległość';
      }
    }
  }

}
